let scrollLeftBtn = document.getElementsByClassName('off-page-carousel__control--previous');
let scrollRightBtn = document.getElementsByClassName('off-page-carousel__control--next');
let cardWidth = 326;
let cardGap = 24;

// Hide buttons if cards fit in screen
let offPageCarousels =  document.getElementsByClassName('off-page-carousel__cards');
for (let i = 0; i < offPageCarousels.length; i++) {

    let index = offPageCarousels[i].getAttribute('data-index');
    let offPageCarousel = document.getElementById('off-page-carousel-' + index);
    let cards = offPageCarousels[i].childElementCount;

    if (offPageCarousels[i].offsetWidth < (cards * cardWidth + (cards - 1) * cardGap)) {
        document.getElementById('off-page-carousel-controls-' + index).classList.remove('off-page-carousel__controls--hidden');
    }

    // Scroll to start on window resize.
    window.addEventListener('resize', () => {
        offPageCarousel.scrollLeft = 0;
    });

    let cardItems = offPageCarousels[i].children;
    Array.from(cardItems).forEach((cardItem) => {
        cardItem.addEventListener('focusin', () => {
            moveItemInViewport(cardItem, offPageCarousel);
        });
    });
}

for (let i = 0; i < scrollRightBtn.length; i++) {

    scrollRightBtn[i].addEventListener('click', function() {
        // Check button attribute to select the respective carousel (in case multiple in page).
        let offPageCarousel = document.getElementById('off-page-carousel-' + this.getAttribute('data-index'));
        offPageCarousel.scrollLeft += cardWidth + cardGap; // Scroll table right 350px

        // Enable the scroll left button.
        this.previousElementSibling.removeAttribute('disabled');

        let cardsCount = offPageCarousel.querySelectorAll('.off-page-carousel__card').length;
        // Disable the scroll right button when we reach the end of the cards.
        if (Math.round( offPageCarousel.scrollLeft ) === Math.round( ( cardsCount * cardWidth ) + ( cardsCount - 1 ) * cardGap - offPageCarousel.offsetWidth ) ) {
            this.setAttribute('disabled', true);
        }
    });

    scrollLeftBtn[i].addEventListener('click', function() {
        // Check button attribute to select the respective carousel (in case multiple in page).
        let offPageCarousel = document.getElementById('off-page-carousel-' + this.getAttribute('data-index'));
        offPageCarousel.scrollLeft -= cardWidth + cardGap; // Scroll offPageCarousel left 350px;

        // Enable the scroll right button.
        this.nextElementSibling.removeAttribute('disabled');

        // Start of table reached, disable left scrolling.
        if (offPageCarousel.scrollLeft === 0) {
            this.setAttribute('disabled', true);
        }
    });

}

/**
 * Moves item in viewport if not completely visible.
 */
function moveItemInViewport(item, carousel) {
    let controls = document.querySelectorAll('button[data-index="' + carousel.getAttribute('id').split('off-page-carousel-').pop() + '"]'); // controls of carousel.
    let sliderContainerRect = carousel.getBoundingClientRect();
    if (
        item.offsetLeft + item.offsetWidth >
        sliderContainerRect.left + carousel.scrollLeft
    ) {
        const scrollDelta =
            item.offsetLeft +
            item.offsetWidth -
            sliderContainerRect.right +
            2 * cardGap;
        carousel.scrollLeft += scrollDelta;

        // Enable the scroll left button.
    }
    if (
        item.offsetLeft <
        sliderContainerRect.left + carousel.scrollLeft
    ) {
        const scrollDelta = item.offsetLeft - cardGap;
        carousel.scrollLeft = scrollDelta;
    }

    if (carousel.scrollLeft > 0) {
        controls.forEach(control => {
            if (control.classList.contains('off-page-carousel__control--previous')){
                control.removeAttribute('disabled');
            }
        });
    }
    else {
        // Start of table reached, disable left scrolling.
        controls.forEach(control => {
            if (control.classList.contains('off-page-carousel__control--previous')){
                control.setAttribute('disabled', true);
            }
        });
    }
}